import CardHeader from "@/components/CardHeader";
import ListRow from "@/components/ListRow";
import { BCTONG } from "@/utils/constants";
import { Button, Card, Center, Container, Flex, Grid, Text, Title } from "@mantine/core";
import { useClipboard } from "@mantine/hooks";
import {
  IconBook2,
  IconBriefcase,
  IconFile,
  IconPhotoDollar,
  IconSignature,
  IconTruckDelivery,
} from "@tabler/icons-react";
import { saveAs } from "file-saver";
import React from "react";

export default function Bctong() {
  const clipboard = useClipboard({ timeout: 500 });

  return (
    <Container mb="md">
      <Title order={4} mb="xs">
        배차통(바른물류연구소) 정보 및 서식자료실
      </Title>
      <Grid>
        <Grid.Col sm={12} md={4}>
          <Card h="100%">
            <CardHeader title="계좌 정보" />
            <ListRow cat="은행명" val={BCTONG.bankName} />
            <ListRow cat="계좌번호" val={BCTONG.bankNumber} />
            <ListRow cat="예금주" val={BCTONG.bankAccountHolder} isLast />

            <Flex justify="flex-end">
              <Button
                mt={8}
                color={clipboard.copied ? "teal" : "blue"}
                onClick={() => clipboard.copy(`${BCTONG.bankName} ${BCTONG.bankNumber} ${BCTONG.bankAccountHolder}`)}
              >
                {clipboard.copied ? "정보 복사 완료" : "계좌 정보 복사"}
              </Button>
            </Flex>
          </Card>
        </Grid.Col>

        <Grid.Col sm={12} md={4}>
          <Card h="100%">
            <CardHeader title="바른물류연구소 정보" />
            <ListRow cat="업체명" val={BCTONG.name} />
            <ListRow cat="사업자등록번호" val={BCTONG.businessNumber} />
            <ListRow cat="주소" val={BCTONG.address} />
            <ListRow cat="대표자명" val={BCTONG.ceoName} isLast />
          </Card>
        </Grid.Col>

        <Grid.Col sm={12} md={4}>
          <Card h="100%">
            <CardHeader title="서류&서식 자료실" />
            <Button
              fullWidth
              variant="light"
              leftIcon={<IconBriefcase size={16} />}
              onClick={() => saveAs("/files/business.jpeg", "바른물류연구소_사업자등록증.jpeg")}
            >
              사업자등록증 다운로드
            </Button>

            <Button
              fullWidth
              variant="light"
              mt="sm"
              leftIcon={<IconPhotoDollar size={16} />}
              onClick={() => saveAs("/files/bank.pdf", "바른물류연구소_통장사본.pdf")}
            >
              통장사본 다운로드
            </Button>

            <Button
              fullWidth
              variant="light"
              mt="sm"
              leftIcon={<IconSignature size={16} />}
              onClick={() => saveAs("/files/contract.hwp", "물류서비스_표준계약서(바른물류연구소).hwp")}
            >
              물류서비스 표준계약서 다운로드
            </Button>

            <Button
              fullWidth
              variant="light"
              mt="sm"
              leftIcon={<IconTruckDelivery size={16} />}
              onClick={() =>
                saveAs(
                  "/files/truck_contract.hwp",
                  "바른물류연구소(주) 화물자동차 운송사업 위수탁계약서.hwp"
                )
              }
            >
              운송차량 위수탁계약서 다운로드
            </Button>

            <Button
              fullWidth
              variant="light"
              mt="sm"
              leftIcon={<IconBook2 size={16} />}
              onClick={() => saveAs("/files/guide.pdf", "배차통 사용가이드.pdf")}
            >
              배차통 사용가이드 다운로드
            </Button>
          </Card>
        </Grid.Col>
      </Grid>

      <Card mt="md">
        <CardHeader title="공지사항" />

        <Center h={300}>
          <Text size="sm" color="gray">
            등록된 공지사항이 없습니다
          </Text>
        </Center>
      </Card>
    </Container>
  );
}
